import _classCallCheck from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { AWS_CLOUDWATCH_CATEGORY } from '../constants.mjs';
import { LogType } from './types.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var LOG_LEVELS = {
  VERBOSE: 1,
  DEBUG: 2,
  INFO: 3,
  WARN: 4,
  ERROR: 5,
  NONE: 6
};
/**
 * Write logs
 * @class Logger
 */

var ConsoleLogger = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {string} name - Name of the logger
   */
  function ConsoleLogger(name) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LogType.WARN;

    _classCallCheck(this, ConsoleLogger);

    this.name = name;
    this.level = level;
    this._pluggables = [];
  }

  _createClass(ConsoleLogger, [{
    key: "_padding",
    value: function _padding(n) {
      return n < 10 ? '0' + n : '' + n;
    }
  }, {
    key: "_ts",
    value: function _ts() {
      var dt = new Date();
      return [this._padding(dt.getMinutes()), this._padding(dt.getSeconds())].join(':') + '.' + dt.getMilliseconds();
    }
  }, {
    key: "configure",
    value: function configure(config) {
      if (!config) return this._config;
      this._config = config;
      return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */

  }, {
    key: "_log",
    value: function _log(type) {
      var loggerLevelName = this.level;

      if (ConsoleLogger.LOG_LEVEL) {
        loggerLevelName = ConsoleLogger.LOG_LEVEL;
      }

      if (typeof window !== 'undefined' && window.LOG_LEVEL) {
        loggerLevelName = window.LOG_LEVEL;
      }

      var loggerLevel = LOG_LEVELS[loggerLevelName];
      var typeLevel = LOG_LEVELS[type];

      if (!(typeLevel >= loggerLevel)) {
        // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
      }

      var log = console.log.bind(console);

      if (type === LogType.ERROR && console.error) {
        log = console.error.bind(console);
      }

      if (type === LogType.WARN && console.warn) {
        log = console.warn.bind(console);
      }

      if (ConsoleLogger.BIND_ALL_LOG_LEVELS) {
        if (type === LogType.INFO && console.info) {
          log = console.info.bind(console);
        }

        if (type === LogType.DEBUG && console.debug) {
          log = console.debug.bind(console);
        }
      }

      var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);
      var message = '';

      for (var _len = arguments.length, msg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        msg[_key - 1] = arguments[_key];
      }

      if (msg.length === 1 && typeof msg[0] === 'string') {
        message = "".concat(prefix, " - ").concat(msg[0]);
        log(message);
      } else if (msg.length === 1) {
        message = "".concat(prefix, " ").concat(msg[0]);
        log(prefix, msg[0]);
      } else if (typeof msg[0] === 'string') {
        var obj = msg.slice(1);

        if (obj.length === 1) {
          obj = obj[0];
        }

        message = "".concat(prefix, " - ").concat(msg[0], " ").concat(obj);
        log("".concat(prefix, " - ").concat(msg[0]), obj);
      } else {
        message = "".concat(prefix, " ").concat(msg);
        log(prefix, msg);
      }

      var _iterator = _createForOfIteratorHelper(this._pluggables),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          var logEvent = {
            message: message,
            timestamp: Date.now()
          };
          plugin.pushLogs([logEvent]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */

  }, {
    key: "log",
    value: function log() {
      for (var _len2 = arguments.length, msg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        msg[_key2] = arguments[_key2];
      }

      this._log.apply(this, [LogType.INFO].concat(msg));
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */

  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, msg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        msg[_key3] = arguments[_key3];
      }

      this._log.apply(this, [LogType.INFO].concat(msg));
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */

  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, msg = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        msg[_key4] = arguments[_key4];
      }

      this._log.apply(this, [LogType.WARN].concat(msg));
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */

  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, msg = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        msg[_key5] = arguments[_key5];
      }

      this._log.apply(this, [LogType.ERROR].concat(msg));
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */

  }, {
    key: "debug",
    value: function debug() {
      for (var _len6 = arguments.length, msg = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        msg[_key6] = arguments[_key6];
      }

      this._log.apply(this, [LogType.DEBUG].concat(msg));
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */

  }, {
    key: "verbose",
    value: function verbose() {
      for (var _len7 = arguments.length, msg = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        msg[_key7] = arguments[_key7];
      }

      this._log.apply(this, [LogType.VERBOSE].concat(msg));
    }
  }, {
    key: "addPluggable",
    value: function addPluggable(pluggable) {
      if (pluggable && pluggable.getCategoryName() === AWS_CLOUDWATCH_CATEGORY) {
        this._pluggables.push(pluggable);

        pluggable.configure(this._config);
      }
    }
  }, {
    key: "listPluggables",
    value: function listPluggables() {
      return this._pluggables;
    }
  }]);

  return ConsoleLogger;
}();

ConsoleLogger.LOG_LEVEL = null;
ConsoleLogger.BIND_ALL_LOG_LEVELS = false;
export { ConsoleLogger };